import Cookies from 'js-cookie';

const COOKIE_KEY = 'dismissedInterstitials';

const getDismissedInterstitials = () => {
  try {
    const raw =
      typeof window !== 'undefined'
        ? Cookies.get(COOKIE_KEY)
        : global.dismissedInterstitials;
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

export const checkInterstitialDismissed = id =>
  !!getDismissedInterstitials()[id];

export const setInterstitialDismissed = id => {
  if (typeof window === 'undefined') return;
  const stored = getDismissedInterstitials();
  stored[id] = true;
  Cookies.set(COOKIE_KEY, JSON.stringify(stored), {
    expires: 1,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
};
